import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';

import { ShaftSealProductSelectorModule } from './shaft-seal-product-selector/shaft-seal-product-selector.module'

import { AppComponent } from './app.component';

if (environment.api_url != '/shaft-seal-products') {
  enableProdMode();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    ShaftSealProductSelectorModule
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./app/javascript/product_search/app/app.module.ts